import { defaultSvgProps, SvgProps } from "../type/props";

export const InfoIcon = (props?: SvgProps) => {
  const { width, height, fill, stroke, style } = defaultSvgProps(props, {
    width: 16,
    height: 16,
    fill: "none",
    stroke: "currentColor",
    style: {
      flexShrink: 0,
    },
  });

  return (
    <svg
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </svg>
  );
};
